import { useCallback, useState } from 'react';

import { ORDER_BY_OPTIONS, OrderByOption } from 'constants/orderBy';

export function useUrlFilters() {
  const params = new URLSearchParams(window.location.search);
  const urlOrderBy = params.get('orderBy') as OrderByOption;

  // Valida se o valor da URL é uma opção válida
  const isValidOrderBy = Object.values(ORDER_BY_OPTIONS).includes(urlOrderBy);
  const orderBy = isValidOrderBy ? urlOrderBy : ORDER_BY_OPTIONS.DEFAULT;

  const [filterOptions, setFilterOptions] = useState<{
    orderBy?: OrderByOption;
    search?: string;
  }>({
    orderBy,
    search: undefined,
  });

  const handleApplyFiltersUrl = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    const { orderBy } = filterOptions;

    if (orderBy && orderBy !== ORDER_BY_OPTIONS.DEFAULT) {
      params.set('orderBy', orderBy);
    } else {
      params.delete('orderBy');
    }

    window.history.replaceState(
      null,
      '',
      params.toString()
        ? `${window.location.pathname}?${params}`
        : window.location.pathname,
    );
  }, [filterOptions]);

  return {
    orderBy,
    filterOptions,
    setFilterOptions,
    handleApplyFiltersUrl,
  };
}

// Re-exporta os tipos para conveniência
export { ORDER_BY_OPTIONS, type OrderByOption };
